import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['alert', 'notice'];

  dismissAlert() {
    this.alertTarget.classList.add('opacity-0');

    setTimeout(() => this.alertTarget.remove(), 300);
  }

  dismissNotice() {
    this.noticeTarget.classList.add('opacity-0');

    setTimeout(() => this.noticeTarget.remove(), 300);
  }
}
